import { serviceWorkerRegister } from './js/sw';

let elem = document.querySelector('.js-progress-text');

export const progress = (p) => {
    if (elem) elem.innerHTML = `${Math.round(p * 100)}%`;
};

export const loadDone = () => {
    console.log('Assets loading finished');
    const { body } = document;

    body.classList.remove('preload');

    setTimeout(() => {
        const pelem = document.querySelector('.preloader');

        if (pelem && pelem.parentNode) {
            pelem.parentNode.removeChild(pelem);
            elem = undefined;
        }
    }, 1200);

    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        serviceWorkerRegister();
    }
};
